import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'help-alert',
  templateUrl: './help.alert.html',
  styleUrls: ['./help.alert.scss']
})
export class HelpAlert implements OnInit 
{
  show: boolean = false
  
  @Input() info         : string
  @Input() description  : string
  @Input() action      ?: string
  @Input() text         : string

  constructor() {}

  ngOnInit(): void {}
}
